// extracted by mini-css-extract-plugin
export var chooseManyCheckbox = "Checkbox_chooseManyCheckbox__JZ5Lh";
export var chooseManyCheckmark = "Checkbox_chooseManyCheckmark__SNVk8";
export var md = "768px";
export var shared = "\"../../../shared.module.css\"";